import api from '@/modules/api'
import { AxiosResponse } from 'axios'
import { IApiResponse } from '@/common/models/interface'
import { AnnouncementRsp, GupStatisticRsp, ArticleRsp } from '@/services/models/Home'

export default class HomeService {
  /**
   * getGupStatistic
   *
   * @param {any} payload
   * @returns {Promise<GupStatisticRsp>}
   * @memberof HomeService
   */
  public async getGupStatistic(): Promise<IApiResponse<GupStatisticRsp>> {
    const res: AxiosResponse<any> = await api.get('Home/GupStatistic')
    return res.data
  }

  /**
   * getAnnouncement
   *
   * @returns {Promise<AnnouncementRsp[]>}
   * @memberof HomeService
   */
  public async getAnnouncement(
    params: {
      page?: number,
      limit?: number,
      orderBy?: string,
    }
  ): Promise<any> {
    return api.get('Home/Announcement/List', {params})
  }

  /**
   * getArticle
   *
   * @param {any} payload
   * @returns {Promise<ArticleRsp>}
   * @memberof HomeService
   */
  public async getArticle(): Promise<IApiResponse<ArticleRsp>> {
    const res: AxiosResponse<any> = await api.get('Home/Article/List')
    return res.data
  }

  /**
   * getEhStatistic
   *
   * @param {any} payload
   * @returns {Promise<any>}
   * @memberof HomeService
   */
  public async getEhStatistic(): Promise<any> {
    return api.get('Home/EhStatistic')
  }

  /**
   * getVideo
   *
   * @returns {Promise<AnnouncementRsp>}
   * @memberof HomeService
   */
  public async getVideo(): Promise<AnnouncementRsp> {
    return api.get('Home/Announcement/Video')
  }
}
